import React from 'react';

// Import Components
import RestaurantTemplate from '../components/restaurant/template/RestaurantTemplate';
import { useHistory, useParams } from 'react-router-dom';
import { foods } from '../constants/food';
import { FoodParams } from '../type';

//음식 선정 결과 페이지
export const RestaurantPage: React.FC = () => {
  const { food } = useParams<FoodParams>();
  if (!foods.hasOwnProperty(food)) {
    const history = useHistory();
    history.push('/');
  }
  return <RestaurantTemplate food={foods[food]} />;
};

export default RestaurantPage;
